import * as angular from 'angular';
import FormThemeEditorBridge from './FormThemeEditorBridge';

angular
  .module('flowingly.runner.library')
  .component('formThemeEditor', FormThemeEditorBridge);
